import React from "react";
import { specialisedMf, indexFunds } from "../../../../data/mutualFundSeoPage";
import style from "../mfseo.module.css";

const SpecialisedMf = () => (
  <div>
    <h2>5. SPECIALIZED MUTUAL FUNDS</h2>
    {specialisedMf.map(text => {
      return <p className={style.greyText}>{text}</p>;
    })}

    <h3>{indexFunds.heading}</h3>
    {indexFunds.content.map(text => {
      if (typeof text === "string") return <p className={style.greyText}>{text}</p>;
      else
        return (
          <>
            <p style={{margin:"8px 0", fontWeight:"bold"}}>{text.type}</p>
            <p className={style.greyText}>{text.def}</p>
          </>
        );
    })}
  </div>
);

export default SpecialisedMf;
